<div class="title-container">
    <span *ngIf="isEditMode" class="input-container">
        <div class="input-with-prefix">
            <span *ngIf="isNumbered" class="prefix">{{ numbering }}</span>

            <input
                type="text"
                placeholder="{{ 'aumico_core_ham_referencing_input_placeholder' | i18next }}"
                [value]="title ? title : ''"
                (input)="onInputChange($event)"
                [style.width]="width"
            />
        </div>
    </span>
    <span *ngIf="!isEditMode && isNumbered && title" class="table-title">{{ numbering + ' ' + title }}</span>
    <span *ngIf="!isEditMode && !isNumbered && title" class="table-title">{{ title }}</span>

    <span
        *ngIf="isEditMode"
        class="ham-icon referencing-icon"
        [ngClass]="{ on: isReferenced, disabled: isDisabled }"
        (click)="onReferencingButtonClick()"
    >
        <i class="bookmark-outline-icon"></i>
    </span>
    <span
        *ngIf="isEditMode"
        class="ham-icon numbering-icon"
        [ngClass]="{ on: isNumbered, disabled: isDisabled }"
        (click)="onNumberingButtonClick()"
    >
        <i class="ordered-list-outline-icon"></i>
    </span>
</div>
